import React from 'react'
import './Houses.css';
import Title from '../HEADER/Title';
const Payment = () => {
  return (
    <div>
        <Title/>
        <h1  id="transac" style={{fontFamily: "Alegreya SC, serif"}}>Your transaction is successfully completed </h1>
    </div>
  )
}

export default Payment